var SdkEnvironment;
(function (SdkEnvironment) {
    SdkEnvironment["ED"] = "ED";
    SdkEnvironment["PROD"] = "PROD";
    SdkEnvironment["STAGE"] = "STAGE";
})(SdkEnvironment || (SdkEnvironment = {}));

export { SdkEnvironment };
